import type { UserTeamState } from "./_model";
//
import { solidstate } from ":setup/qstate";
import { For, Match, Show, Switch, createEffect, createMemo } from "solid-js";
import { TableTeamMembers } from "./tables/team-members";
import { TableRecievedRequests } from "./tables/recieved-requests";
import { TableSentRequests } from "./tables/sent-requests";
import { Loader2 } from ":src/components/loaders";
import { leave_team } from "./apis";
import { user_requests } from "../SHARED/apis/";
import { global } from ":shared/app";
import { TABS_AND_STATES, TABS_KEYS } from "./const";
import { CreateTeamForm } from "./components/create-team-form";
import { getDateDetails } from "@qundus.tc/agnostic.helpers/date";
import { TeamingHistory } from "../history";

export default function MyTeam() {
  const $details = solidstate.createAsync(user_requests.get);
  const $active_tab = solidstate.create(null);
  const $user_team_state: () => UserTeamState = $details.derive((value) => {
    if (value == undefined || value.team_info == undefined) {
      return "teamless";
    }
    if (value.role === "leader") {
      return "leader";
    }
    return "member";
  });

  const $team_info = createMemo(() => {
    const info = $details.value?.team_info;
    if (info == undefined) {
      return undefined;
    }
    const date = getDateDetails(info.created_at);
    return {
      ...info,
      date: `${date.month_short}-${date.day_number}-${date.day_short}`,
    };
  });

  createEffect(() => {
    const state = $details.state;
    if (state.success) {
      // const value = $details.value
      $active_tab.set(getActiveTab());
    }
  });

  function getActiveTabs() {
    const state = $user_team_state();
    const result: { [Key in keyof typeof TABS_AND_STATES]?: string | null } = {};
    for (const tab in TABS_AND_STATES) {
      const name = TABS_AND_STATES[tab][state];
      result[tab] = name;
    }
    return result;
  }
  function getActiveTab(): keyof typeof TABS_AND_STATES {
    const tabs = getActiveTabs();
    let result = undefined;
    for (const tab in tabs) {
      const title = tabs[tab];
      if (title != undefined) {
        result = tab;
        break;
      }
    }
    return result;
  }

  return (
    <section class="flex flex-col w-full h-full overflow-hidden sm:(px-5 py-3) <sm:(px-3 py-2)">
      {/* title */}
      <h1 class="flex flex-row min-h-40px h-40px max-h-40px text-1.1rem whitespace-nowrap capitalize gap-1 overflow-hidden <sm:(!flex !flex-col text-1rem !min-h-55px !h-55px !max-h-55px)">
        {$team_info() != undefined ? (
          <p class="w-full overflow-x-auto overflow-y-hidden whitespace-nowrap">{$team_info().name}</p>
        ) : (
          <p>My Team</p>
        )}
        {$team_info() != undefined && (
          <p class="flex flex-row w-full text-0.5em gap-2 px-1 items-center justify-end overflow-hidden <sm:(flex-wrap !justify-between )">
            <span
              class={
                "before:(content-['Role:_'] text-text-alt) " +
                " " +
                ($details.value.role === "leader" ? "text-text" : "text-brand")
              }
            >
              {$details.value.role}
            </span>
            <span class="before:(content-['Created_at:_'] text-text-alt)">{$team_info().date}</span>
          </p>
        )}
      </h1>
      {/* tabs and actions button */}
      <div class="flex flex-row w-full justify-between <sm:(!flex-col-reverse py-2)">
        <div class="flex flex-row w-full h-55px justify-start items-center gap-2 overflow-hidden <sm:(justify-between)">
          <For each={TABS_KEYS}>
            {(tab, index) => {
              const $title = createMemo(() => TABS_AND_STATES[tab][$user_team_state()]);
              const $hidden = createMemo(() => $title() == undefined);
              const $active = createMemo(() => $active_tab.value === tab);
              const $count = createMemo(() => {
                if (tab === "received_requests") {
                  return $details.value?.received_requests?.length;
                }
                if (tab === "sent_requests") {
                  return $details.value?.sent_requests?.length;
                }
                return undefined;
              });
              return (
                <Show when={!$hidden()}>
                  <p
                    //
                    class={
                      "relative flex w-fit h-fit text-20px font-bold capitalize cursor-pointer <sm:(!text-16px)" +
                      " " +
                      ($active() ? "text-brand border-b-5 border-solid border-brand" : "text-text-alt")
                    }
                    onclick={() => $active_tab.set(tab)}
                  >
                    {$title()}
                    {/* badge */}
                    <Show when={$count() != undefined && $count() > 0}>
                      <span class="flex bg-badge-bg text-badge-text  min-w-0.9rem min-h-0.9rem rounded-full items-center justify-center text-0.5rem <sm:(text-0.47rem min-w-0.7rem min-h-0.5rem)">
                        {$count()}
                      </span>
                    </Show>
                  </p>
                </Show>
              );
            }}
          </For>
        </div>
        <div
          class={
            "flex flex-row w-full h-40px gap-1 justify-end items-center  children:(!w-fit !py-1 !text-14px !h-full)" +
            " " +
            "lt-sm:(justify-between)" +
            " " +
            (!$details.state.success ? "!hidden" : "")
          }
        >
          {/* {$team_info() != undefined && (
            <button
              class="form-btn"
              onClick={() => {
                global.store.actions.popop.pushModal({
                  title: "Team Action History",
                  element: () => <TeamingHistory />,
                });
              }}
            >
              View History
            </button>
          )} */}
          <button
            class="form-btn !bg-bg !text-brand-gray !border-1 !border-solid !border-brand-gray"
            onclick={async () => {
              // $active_tab.set(null);
              global.store.actions.popop.pushModal({
                title: $team_info() == undefined ? "Create Team" : "Update Team",
                noExpand: true,
                element(props) {
                  return (
                    <div class="flex w-full px-2 md:w-50% ">
                      <CreateTeamForm
                        details={$details.value}
                        onCreate={(data) => {
                          if ($team_info() == undefined) {
                            props.actions.close();
                          }
                          $details.set({ ...data });
                        }}
                      />
                    </div>
                  );
                },
                outerContainer: {
                  class: "min-w-full lg:(!min-w-50% !w-50%)",
                },
                // innerContainer: {
                //   class: "!block !w-fit",
                // },
                // innerContainer: {
                //   class: "block !px0 !mx0 debug$",
                // },
              });
            }}
          >
            {$team_info() == undefined ? "Create Team" : "Update Team"}
          </button>
          {$team_info() != undefined && (
            <button
              class="form-btn !text-error !bg-bg border-1 border-solid border-error"
              onClick={() => {
                global.store.actions.popop.pushConfirmDialog({
                  type: "warn",
                  message: "Are you sure you want to leave the team?",
                  note: "this is irreversable!",
                  events: {
                    async onConfirmed() {
                      return leave_team.get().then((value) => {
                        // console.log("team leave returns :: ", value);
                        global.store.actions.toast.pushToast({
                          type: "success",
                          message: "don't look back, future endevours await!",
                        });
                        $details.set(value);
                        $active_tab.set(getActiveTab());
                      });
                    },
                  },
                });
              }}
            >
              Leave Team
            </button>
          )}
        </div>
      </div>
      <section class="flex flex-col w-full h-full overflow-hidden">
        <Switch>
          <Match when={$details.state.loading}>
            <Loader2 msg="Loading Memebrs And Requests..." />
          </Match>
          <Match when={$details.state.failed}>error occured while loading user requests details {$details.error}</Match>
          <Match when={$details.state.success}>
            <Switch>
              <Match when={$active_tab.value === "members"}>
                <TableTeamMembers details={$details.value} />
              </Match>
              <Match when={$active_tab.value === "received_requests"}>
                <TableRecievedRequests details={$details.value} onUpdate={(data) => $details.set({ ...data })} />
              </Match>
              <Match when={$active_tab.value === "sent_requests"}>
                <TableSentRequests details={$details.value} onUpdate={(data) => $details.set({ ...data })} />
              </Match>
              {/* <Match when={true}>
                <CreateTeamForm details={$details.value} onCreate={(data) => $details.set({ ...data })} />
              </Match> */}
            </Switch>
          </Match>
        </Switch>
      </section>
    </section>
  );
}
